(() => {
  if (window.drvProductBenchmarkReady) return;
  window.drvProductBenchmarkReady = true;
  document.addEventListener('submit', (event) => {
    const form=event.target;
    const productInfo=form.closest?.('product-info');
    if(!productInfo) return;
    for(const row of productInfo.querySelectorAll('.drv-compatible-accessories__item')) {
      const checkbox=row.querySelector('.drv-compatible-accessories__input');
      const select=row.querySelector('[data-drv-accessory-variant]');
      if(checkbox?.checked && select && !select.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        select.setCustomValidity('Please choose an accessory option.');
        select.reportValidity();
        return;
      }
    }
  }, true);
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-drv-accessory-variant]');
    if (!select) return;
    select.setCustomValidity('');
    const row = select.closest('.drv-compatible-accessories__item');
    const input = row?.querySelector('.drv-compatible-accessories__input');
    const option = select.selectedOptions[0];
    if (!input || !option) return;
    const available = option.dataset.available === 'true';
    input.value = option.value;
    input.disabled = !available;
    if (!available) input.checked = false;
    row.classList.toggle('is-placeholder', !available);
    const price = row.querySelector('[data-drv-accessory-price]');
    if (price) price.textContent = option.dataset.price;
    const compare = row.querySelector('[data-drv-accessory-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    const image = row.querySelector('.drv-compatible-accessories__media img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
    const status = row.querySelector('[data-drv-accessory-status]');
    if (status) status.hidden = available;
    row.querySelectorAll('[data-drv-accessory-qty]').forEach(button => { button.disabled = !available; });
    input.dispatchEvent(new Event('change', {bubbles: true}));
  });
  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-drv-accessory-qty]');
    if (quantityButton) {
      event.preventDefault();
      event.stopPropagation();

      const row = quantityButton.closest('.drv-compatible-accessories__item');
      const bundleInput = row?.querySelector('.drv-compatible-accessories__input');
      if (!bundleInput || bundleInput.disabled) return;

      const current = Math.max(1, Number(bundleInput.dataset.drvBundleQuantity || 1));
      const delta = quantityButton.dataset.drvAccessoryQty === 'increase' ? 1 : -1;
      const next = Math.max(1, current + delta);
      bundleInput.dataset.drvBundleQuantity = String(next);
      const output = row.querySelector('[data-drv-accessory-qty-output]');
      if (output) output.textContent = String(next);
    }
  });
})();
